<template>
    <div class="home-footer flex align-center justify-center flex-direction">
        <div class="flex align-center justify-between tabs cursor" style="width: 100%;">
            <a href="https://support.qq.com/products/57964/" target="_blank">悟空投票用户交流</a>
            <a href="https://support.qq.com/products/57964/team/" target="_blank">悟空投票的故事</a>
            <el-popover
                    placement="right"
                    trigger="hover">
                <el-image
                        style="width: 150px; height: 150px"
                        src="https://assets.pfotoo.com/images/wechat.qrcode.jpg"
                        fit="cover"></el-image>
                <a slot="reference">微信公众号</a>
            </el-popover>
            <el-popover
                    placement="right"
                    trigger="hover">
                <el-image
                        style="width: 150px; height: 150px"
                        src="https://assets.pfotoo.com/images/work/qycode.jpg"
                        fit="cover"></el-image>
                <a slot="reference">联系我们</a>
            </el-popover>
        </div>
        <div class="flex align-center justify-center copy">
            西安空空如也网络科技有限公司 版权所有 <a
                href="https://beian.miit.gov.cn/" style="color:#91ADE9;padding-left:10px;text-decoration: none;">陕ICP备18022589号-1</a>
        </div>

    </div>
</template>
<script>
  import App from '../../../util/comfun'
  export default {
    props:{

    },
    data () {
      return {
        path:'',
      }
    },
    methods:{
      setActive(){
        console.log('setActive',this.$route.path)
        this.path=this.$route.path
      },
    },
    mounted(){
      this.setActive()
    },
  }
</script>

<style>
.home-footer{
    width: 1024px;
    height: 258px;
    box-sizing: border-box;
}
    .home-footer .tabs{
        font-size: 18px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        text-align: left;
        color: #5d5d5d;
        line-height: 46px;
        margin-bottom: 30px;
    }
.home-footer .tabs a{
    text-decoration: none;
    color: #5d5d5d;
}
.home-footer .copy{
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: #999999;
    line-height: 38px;
}
</style>


// WEBPACK FOOTER //
// src/pages/components/home/footer.vue